import { CloseButton, CloseButtonProps } from "@chakra-ui/react";

export default function CustomCloseButton({ onClick, ...rest }: CloseButtonProps) {
  return (
    <CloseButton
      size="xs"
      position="absolute"
      right="2.5"
      sx={{ _hover: { bg: "transparent", color: "fg.emphasized" } }}
      _focus={{ boxShadow: "none" }}
      _focusVisible={{ boxShadow: "none" }}
      onClick={onClick}
      {...rest}
    />
  );
}
